import Vue from 'vue'
import VueRouter from 'vue-router'
// 一级页面
import firstPages from './firstPages/firstPages'
// 学习中心路由
import study from './study/study'
// 课程中心路由
import course from './course/course'
// 新闻中心路由
import news from './news/news'
// 直播中心路由
import live from './live/live'
// 资料库路由
import datebase from './datebase/datebase'
//购物车
import cart from './cart/cart'
// 其他也没
import pages from './pages/pages'

import Artificial from './Ai/Ai'

import store from '../store/index'

import { getUrl, getMessage } from '../api/index'

Vue.use(VueRouter)

const routes = [
  ...firstPages,
  ...study,
  ...course,
  ...news,
  ...live,
  ...cart,
  ...datebase,
  ...pages,
  ...Artificial

]

const router = new VueRouter({
  mode: 'history',
  routes: routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  console.log('to', to, from, to.meta.requiresAuth)

  // 3. 检查：若当前路径是排除路由 → 不执行重定向
  const excludeRouteRegex = /^\/credit\/[^\/]+\/[^\/]+$/;
  if (excludeRouteRegex.test(to.path)) {
    console.log("当前路径是排除路由，不跳转");
    // return;
  } else {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if (isMobile) {
      getMessage({
        key: 'url_scheme'
      }).then(res => {
        console.log('res',res)
        window.location.href = res.data
      })
    }
  }

  if (to.meta.requiresAuth && !isAuthenticated()) {
    console.log('toto')
    next({
      name: 'login',
      query: { redirect: to.fullPath }
    });
    return;
  }

  // 其他情况正常放行
  next();
})
function isAuthenticated() {
  console.log('store', store.state.user.userid, !store.state.user.userid)
  return store.state.user.userid;
}

export default router
